<template>
  <div class="wg-row" style="height:calc(100vh - 60px);">
    <!-- Sub menu con scelta categorie -->
    <world-sub-menu :selected="pageId" :list="list" @changePage="changePage">
      <template v-slot:content>
        <!-- Version -->
        <div v-if="pageId === 'version'" class="wg-row" style="justify-content:center;">
          <div
            class="com-anm22-page-title"
            style="font-size:24px;"
          >{{ $anm22.strLang(lang, 'Version', 'Versione') }}</div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-app-text-xxl">ANM22 Contacts V</div>
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-app-text-l">{{ version }}</div>
        </div>
      </template>
    </world-sub-menu>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WorldSubMenu from "../../../../world/spa/components/WorldSubMenu.vue";

export default {
  data() {
    return {
      loading: false,
      pageId: "version",
      // Version
      version: process.env.VERSION
    }
  },
  components: {
    WorldSubMenu,
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      workSelected: state => state.workSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight
    }),
    list() {
      //Bisogna fare controllo licenza vircos
      const list = [];
      list.push({
        id: "version",
        img: this.$anm22.icons.getWorldIcon("settingsVer"),
        label: this.$anm22.strLang(this.lang, "Version", "Versione")
      });
      return list;
    },
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.workSelected
      );
    },
  },
  methods: {
    changePage(elem) {
      if (typeof elem == "string") {
        elem = this.list.find(l => l.id === elem);
      }
      this.pageId = elem.id;
    }
  },
  created() {
    this.$Progress.finish();
  }
}
</script>

<style lang="scss" scoped>

</style>
